var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"id":"password_reset"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('PasswordReset')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }